/**
 *
 */
(function (window, undefined) {
  'use strict';
  var Run = function (
    $http,
    $q,
    userSrvc,
    messaggiFctr,
    labelSrvc,
    loggerSrvc,
    CONSTANTS,
    ssocoreServices
  ) {
    var userSrvcDefer = $q.defer();
    var labelSrvcDefer = $q.defer();
    userSrvc.abilitazioniPronte = userSrvcDefer.promise;
    labelSrvc.labelsPronte = labelSrvcDefer.promise;

    ssocoreServices.caricaContesto(
      function (response) {
        startAbilitazioniPromise();
        startLabelsPromise();
        startLoggerPromise();
      },
      function (reason) {}
    );

    var startAbilitazioniPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.USER,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            userSrvcDefer.reject(response);
            return;
          }
          userSrvc.user = response.data.result.profile;
          userSrvc.abilitazioni = response.data.result.abilitazioni;
          if (window.CblBrioLoader) {
            CblBrioLoader.hideLoader();
          }
          userSrvcDefer.resolve(true);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
          userSrvcDefer.reject(reason);
        }
      );
    };

    var startLabelsPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LABEL,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            labelSrvcDefer.reject(response);
            return;
          }
          labelSrvc.labels = response.data.result;
          labelSrvcDefer.resolve(true);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
          labelSrvcDefer.reject(reason);
        }
      );
    };

    var startLoggerPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            return;
          }
          loggerSrvc.setupLogger(response.data.result);
          labelSrvc.develop = loggerSrvc.levelEnabled(loggerSrvc.FINE);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
        }
      );
    };
  };

  Run.$inject = [
    '$http',
    '$q',
    'CdintUserSrvc',
    'CdintMessaggiFctr',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CDINT_CONSTANTS',
    'ssocoreServices',
  ];
  angular.module('cbl.cartadebitoint.wa').run(Run);
})(window);



//////////////////
// WEBPACK FOOTER
// ./app/app.run.js
// module id = 3
// module chunks = 0